import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Form, Button, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../ruta-server/BaseApi";
import axios from "axios";
import estiloss from "./Password_reset.module.css";
import HeaderSmall from "../../components/HeaderSmall/HeaderSmall";

export function Password_reset() {
  const params = useParams();
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  //const navigate = useNavigate();

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: Yup.object(newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await axios.post(
          `${BASE_API}/api/password_reset/confirm/`,
          {
            password: formValue.password,
            token: params.ref,
          }
        );
        toast.success(
          "La contraseña se ha restablecido, ya puede regresar al inicio de sesión"
        );
        formik.resetForm();
        return response;
      } catch (error) {
        toast.error(
          "Este enlace ya ha sido utilizado o no es válido. Por favor, solicita un nuevo enlace en la sección recuperar contraseña"
        );
      }
    },
  });

  function initialValues() {
    return {
      password: "",
    };
  }

  function newSchema() {
    return {
      password: Yup.string()
        .required("La contraseña es obligatoria")
        .min(8, "La contraseña debe tener al menos 8 caracteres")
        .matches(/\d/, "La contraseña debe contener al menos un número")
        .test(
          "not-all-digits",
          "La contraseña no puede ser completamente numérica",
          (value) => {
            return !/^\d+$/.test(value);
          }
        ),
    };
  }

  const passwordValidation = {
    minLength: formik.values.password.length >= 8,
    hasUppercase: /[A-Z]/.test(formik.values.password),
    hasLowercase: /[a-z]/.test(formik.values.password),
    hasNumber: /\d/.test(formik.values.password),
    hasSpecialChar: /[@$!%*?&]/.test(formik.values.password),
  };

  return (
    <div className={estiloss.contenedor}>
      <div onSubmit={formik.handleSubmit} className={estiloss.rectangulo}>
        <HeaderSmall btTitulo="Reestablecer contraseña" />
        <Form className={estiloss.formpersonalizado}>
          <div>
            <Form.Input
              name="password"
              type={showPasswordNew ? "text" : "password"}
              placeholder="Nueva Contraseña"
              icon={{
                name: showPasswordNew ? "eye" : "eye slash",
                link: true,
                onClick: () => setShowPasswordNew(!showPasswordNew),
              }}
              value={formik.values.password}
              onChange={formik.handleChange}
            />
          </div>
          <div
            style={{
              fontSize: "12px",
              lineHeight: "1",
              padding: "0",
              margin: "0",
            }}
          >
            {[
              {
                condition: passwordValidation.minLength,
                text: "Mínimo 8 caracteres",
              },
              {
                condition: passwordValidation.hasUppercase,
                text: "Al menos una mayúscula",
              },
              {
                condition: passwordValidation.hasLowercase,
                text: "Al menos una minúscula",
              },
              {
                condition: passwordValidation.hasNumber,
                text: "Al menos un número",
              },
              {
                condition: passwordValidation.hasSpecialChar,
                text: "Al menos un carácter especial (@$!%*?&)",
              },
            ].map(({ condition, text }, index) => (
              <p
                key={index}
                style={{ display: "flex", alignItems: "center", margin: "0" }}
              >
                <Icon
                  name={condition ? "check" : "close"}
                  color={condition ? "green" : "red"}
                  size="small"
                  style={{ marginRight: "5px" }}
                />
                {text}
              </p>
            ))}
          </div>
          <Button
            type="submit"
            content="Reestablecer contraseña"
            className={estiloss.btonAc}
            fluid
            disabled={
              !(
                passwordValidation.minLength &&
                passwordValidation.hasUppercase &&
                passwordValidation.hasLowercase &&
                passwordValidation.hasNumber &&
                passwordValidation.hasSpecialChar
              )
            }
          />
        </Form>
        <Link to="/login" className={estiloss.linkf}>
          Iniciar sesión
        </Link>
        <ToastContainer
          position="bottom-center"
          autoClose={1500}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover={false}
        />
      </div>
    </div>
  );
}
